import { Link } from 'react-router-dom';
import useTitle from '../../../hooks/useTitle';
import content from './HomeCampaign2026.json';
import './HomeCampaign2026.css';

const whatsappUrl = `https://wa.me/${content.contact.whatsappNumber}?text=${encodeURIComponent(content.contact.message)}`;

function Arrow() {
  return <span aria-hidden="true">↗</span>;
}

function WhatsAppButton({ children, secondary = false }) {
  return <a className={`mc26-button${secondary ? ' mc26-button-dark' : ''}`} href={whatsappUrl} target="_blank" rel="noopener noreferrer">
    {children}<Arrow />
  </a>;
}

export default function HomeCampaign2026() {
  useTitle(content.title);
  return <div className="mc26">
    <a className="mc26-skip" href="#campaign-main">Langsung ke konten</a>
    <header className="mc26-header">
      <div className="mc26-container mc26-header-inner">
        <a href="/" className="mc26-brand" aria-label={`${content.brand} home`}><span className="mc26-brand-symbol" aria-hidden="true">m<span>.</span></span>{content.brand}</a>
        <nav aria-label="Navigasi utama">
          <a className="mc26-nav-section" href="#pendekatan">{content.nav.approach}</a>
          <a className="mc26-nav-section" href="#pengalaman">{content.nav.experience}</a>
          <Link className="mc26-login" to="/login">{content.nav.login}<Arrow /></Link>
        </nav>
      </div>
    </header>

    <main id="campaign-main">
      <section className="mc26-hero">
        <div className="mc26-container mc26-hero-grid">
          <div>
            <p className="mc26-eyebrow"><span aria-hidden="true" />{content.hero.eyebrow}</p>
            <h1>{content.hero.lead}<br /><em>{content.hero.highlight}</em><br />{content.hero.ending}</h1>
            <p className="mc26-hero-description">{content.hero.description}</p>
            <WhatsAppButton>{content.hero.cta}</WhatsAppButton>
            <p className="mc26-note">{content.hero.note}</p>
          </div>
          <aside className="mc26-shift" aria-label={content.hero.asideLabel}>
            <div className="mc26-shift-top"><span>{content.hero.asideLabel}</span><span aria-hidden="true">2026</span></div>
            <div className="mc26-old"><span className="mc26-small-label">{content.hero.oldLabel}</span>{content.hero.oldRoles.map(role => <p key={role}>{role}<span aria-hidden="true">↗</span></p>)}</div>
            <div className="mc26-new"><span className="mc26-small-label">{content.hero.newLabel}</span><p>{content.hero.newRole}<span aria-hidden="true">↗</span></p></div>
            <p className="mc26-shift-note">{content.hero.asideNote}</p>
          </aside>
        </div>
      </section>

      <section className="mc26-position">
        <div className="mc26-container">
          <p className="mc26-eyebrow">{content.position.eyebrow}</p>
          <h2>{content.position.title}<br /><span>{content.position.highlight}</span></h2>
          <p className="mc26-position-description">{content.position.description}</p>
        </div>
      </section>

      <section className="mc26-approach mc26-container" id="pendekatan">
        <div className="mc26-section-heading"><p className="mc26-eyebrow">{content.approach.eyebrow}</p><h2>{content.approach.title}</h2></div>
        <div className="mc26-steps">{content.approach.steps.map(step => <article key={step.number}><span className="mc26-step-number">{step.number}</span><h3>{step.title}</h3><p>{step.description}</p></article>)}</div>
      </section>

      <section className="mc26-erp"><div className="mc26-container mc26-erp-grid">
        <div><p className="mc26-eyebrow">{content.erp.eyebrow}</p><h2>{content.erp.title}<br /><span>{content.erp.highlight}</span></h2></div>
        <div><p>{content.erp.description}</p><WhatsAppButton secondary>{content.erp.cta}</WhatsAppButton></div>
      </div></section>

      <section className="mc26-experience mc26-container" id="pengalaman">
        <div className="mc26-years"><span>{content.experience.number}</span><p>{content.experience.unit}</p></div>
        <div><h2>{content.experience.title}</h2><p>{content.experience.description}</p><a className="mc26-story" href={content.experience.personalUrl} target="_blank" rel="noopener noreferrer"><span>{content.experience.personalLabel}<strong>{content.experience.personalName}</strong></span><Arrow /></a></div>
      </section>

      <section className="mc26-contact"><div className="mc26-container mc26-contact-inner">
        <div><p className="mc26-eyebrow">{content.contact.eyebrow}</p><h2>{content.contact.title}</h2><p>{content.contact.description}</p></div>
        <div className="mc26-contact-action"><WhatsAppButton>{content.contact.cta}</WhatsAppButton><a className="mc26-phone" href={whatsappUrl} target="_blank" rel="noopener noreferrer">WhatsApp · {content.contact.phone}</a></div>
      </div></section>
    </main>
    <footer className="mc26-footer mc26-container"><div><strong>{content.brand}</strong><p>{content.company}</p><p>{content.footer.tagline}</p></div><p>© {new Date().getFullYear()} {content.footer.copyright}</p></footer>
  </div>;
}
